<div class="file-input">
  <label>{{ labelText | translate }}</label>
  <div class="file-control">
    <input id="file" class="real-file-input" type="file" (change)="handleAddFile($event)" />
    <span class="file-name">{{ fileName ? fileName : (inputText | translate) }}</span>
    <button class="upload-file-btn">{{ buttonText | translate }}</button>
  </div>
</div>
